module.exports = __webpack_public_path__ + "static/media/flr-ps4-glam.ed2da4b6.jpeg";